import React, {useState, useEffect} from 'react'
import DatePickers from '../prawnik/statystyka_profilu/DatePickers';
import Filter from './Filter';

function AllFilters({from_date, to_date, setFromDate, setToDate, setBannerType, setChosenCategory, setReferer}) {
    const [referrers_list, setReferersList] = useState([]);
    let referer_options = [];
    const categories_options = [
        {'value': null, 'label': 'Wszystkie'},
        {'value': 'dzieci-i-rozwody', 'label': 'Dzieci i rozwody'},
        {'value': 'praca', 'label': 'Praca'},
        {'value': 'podatki-3', 'label': 'Podatki'},
        {'value': 'koronawirus-covid-19', 'label': 'KORONAWIRUS (COVID-19)'},
        {'value': 'sprawy-ubezpieczeniowe', 'label': 'Sprawy ubezpieczeniowe'},
        {'value': 'umowy', 'label': 'Umowy'}
    ];

    const banner_options  = [
        {'value': null, 'label': 'Wszystkie'},
        {'value': 1, 'label': 'Bezpłatne pytanie'},
        {'value': 2, 'label': 'Bezpłatna konsultacja'},
        {'value': 3, 'label': 'Płatna konsultacja'},
    ];
    

    useEffect(() => {
        fetch('/api/analytic-referers/').then(res => {
            if(res.ok) {
                res.json().then(data => {
                    setReferersList(data)
                })
            }
        })
    },[])

    referrers_list.forEach(item => {
        if (item !== null) 
            referer_options.push({
                'value': item,
                'label': item
            })
        }    
    )
    referer_options.unshift({'value': null, 'label': 'Wszystkie'})

  return (
    <>
        <DatePickers from_date={from_date} to_date={to_date} setFromDate={setFromDate} setToDate={setToDate}/>
        <div className="select-boxes">
        <Filter method={setBannerType} title={'Rodzaj banera'} options={banner_options}/>
        <Filter method={setChosenCategory} title={'Kategoria'} options={categories_options}/>
        <Filter method={setReferer} title={'Referer'} options={referer_options}/>
        </div>
    </>
  )
}

export default AllFilters